import { render, staticRenderFns } from "./SinglePractice.vue?vue&type=template&id=4dd550cf&scoped=true&"
import script from "./SinglePractice.vue?vue&type=script&lang=js&"
export * from "./SinglePractice.vue?vue&type=script&lang=js&"
import style0 from "./SinglePractice.vue?vue&type=style&index=0&id=4dd550cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd550cf",
  null
  
)

export default component.exports